export const getScrollContainer = () => {
    if (typeof document === "undefined") {
        return null;
    }

    return document.querySelector(".home-wrapper.final") || document.scrollingElement || document.documentElement;
};

export const getScrollTop = () => {
    const container = getScrollContainer();

    if (!container) {
        return 0;
    }

    return container === document.documentElement || container === document.body
        ? window.scrollY || window.pageYOffset || 0
        : container.scrollTop;
};

export const getScrollableHeight = () => {
    const container = getScrollContainer();

    if (!container) {
        return 0;
    }

    return container.scrollHeight - container.clientHeight;
};

export const scrollToPosition = (top, behavior = "auto") => {
    const container = getScrollContainer();

    if (!container) {
        return;
    }

    if (container === document.documentElement || container === document.body) {
        window.scrollTo({ top, behavior });
        return;
    }

    container.scrollTo({ top, behavior });
};
